/* eslint-disable prefer-destructuring */
import styled, { css } from "styled-components";
import * as CashPrice from "../price/CashPrice";
import * as CommonBasketItems from "../BasketItems";
import { theme } from "../../theme/toyotaTheme";
import { ToggleIconWrapper } from "../../globals/IconWrapper";

export const HeaderToggle = styled(CommonBasketItems.HeaderToggle)`
    margin-bottom: 12px;
`;

export const HeaderToggleInner = styled(CommonBasketItems.HeaderToggleInner)`
    ${CashPrice.Text} {
        font-family: ${theme.fonts.semiBold};
        font-size: 1.3rem;
        color: ${theme.colors.primaryBlack};

        /* For Israel there is an extra div inside the wrapper component which also needs this styling.*/
        div {
            font-family: ${theme.fonts.semiBold};
            font-size: 1.3rem;
            color: ${theme.colors.primaryBlack};
        }
    }

    ${({ theme: localTheme }) =>
        localTheme.isRTL &&
        css`
            flex-direction: row-reverse;
        `};

    ${ToggleIconWrapper} {
        margin-right: ${theme.space[1]}px;
        /* Fix vertical alignment icon */
        .icon {
            position: relative;
            top: -2px;
        }
    }

    html[dir="rtl"] & {
        ${ToggleIconWrapper} {
            margin-left: ${theme.space[1]}px;
            margin-right: 0;
        }
    }
`;

export const ContentWrapper = CommonBasketItems.ContentWrapper;

export const HeaderToggleTitle = styled.div<{ isRTL?: boolean }>`
    display: flex;
    align-items: center;
    align-self: flex-start;
    column-gap: ${theme.space[1]}px;
    ${({ theme: localTheme }) =>
        localTheme.isRTL
            ? css`
                  flex-direction: row-reverse;
                  margin-left: auto;
              `
            : css`
                  margin-right: auto;
              `};

    font-family: ${theme.fonts.semiBold};
    font-size: 1.3rem;
`;

export const Counter = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: ${theme.space[1]}px;
    padding: 4px;
    font-family: ${theme.fonts.regular};
    font-size: 1.1rem;
    line-height: 50%;
    color: ${theme.colors.primaryWhite};
    background-color: ${theme.colors.primaryBlack};
    border: 2px solid ${theme.colors.primaryBlack};
    border-radius: 60px;

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[1]}px;
    }
`;
